import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";

import App from "./App";
import { AuthProvider } from "./hooks/useAuth";
import { queryClient } from "./lib/queryClient";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./index.css";

// Client entry (template §5). Mode B, so this mounts rather than hydrates.
//
// Provider order is forced: QueryClientProvider outermost (AuthProvider clears the cache on sign
// out), BrowserRouter above AuthProvider (the auth layer redirects and reads the path), AuthProvider
// above App (every route and page calls useAuth).
createRoot(document.getElementById("root")).render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </QueryClientProvider>
);
